import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationHK from './locales/zh-HK/translation.json';
import translationCN from './locales/zh-CN/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  'zh-HK': {
    translation: translationHK,
  },
  'zh-CN': {
    translation: translationCN,
  },
  en: {
    translation: translationEN,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-HK',
    supportedLngs: ['zh-HK', 'zh-CN', 'en'],
    load: 'currentOnly',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
